import { PermissionService, PermissionLabelService } from "@/common/api.service"
import { FETCH_PERMISSIONS,FETCH_PERMISSION_LABELS, RESET_STATE} from "./actions.type"
import { SET_PERMISSIONS,SET_PERMISSION_LABELS, STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
        allpermissions: [],
        permissionlabels:[],
    }
}

let state = initialState()

const getters = {
    allpermissions(state) {
        return state.allpermissions
    },
    permissionLabels(state) {
        return state.permissionlabels
    },
}

const actions = {
    async [FETCH_PERMISSIONS](context, slug) {
        const { data } = await PermissionService.get(slug)
        context.commit(SET_PERMISSIONS, data.data)
        return data;
    },
    async [FETCH_PERMISSION_LABELS](context, slug) {
        const { data } = await PermissionLabelService.get(slug)
        context.commit(SET_PERMISSION_LABELS, data.data)
        return data;
    },
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {     
    [SET_PERMISSIONS](state, data) {
        state.allpermissions = data
    },
    [SET_PERMISSION_LABELS](state, data) {
        state.permissionlabels = data
    },
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};